import { ISignable } from "@/mixins/SignalsMixin/interfaces";
import { CandidateAdvisor, ICandidateAdvisor } from "@/services/DTOs/CandidateAdvisor";
import { Column } from "@/services/DTOs/Column";
import { Compensation } from "@/services/DTOs/Compensation";
import { Person } from "@/services/DTOs/Person";
import { SignableType } from "@/services/DTOs/SignalDetail";
import { ICandidateApplicationStep } from "./EditApplicationStep";

export enum CandidateStatus {
  STARTED = "started",
  PRE_SCREENING = "pre_screening",
  COMPLETED = "completed",
  RETRACTED = "retracted",
  DISQUALIFIED = "disqualified",
  INVITED = "invited",
  MUTUALLY_MATCHED = "mutually_matched",
  UNSET = "unset",
  DELIVERED = "delivered",
  PENDING_DELIVERY = "pending_delivery"
}

export interface ICandidate {
  id: string;
  personId: string;
  opportunityId: string;
  column?: Column;
  position: number;
  created: string | Date;
  interested?: string | Date;
  reviewed?: Date;
  retracted?: Date;
  ranking?: number;
  person?: Person;
  compensation?: Compensation;
  disqualified?: boolean;
  applicationStep?: ICandidateApplicationStep;
  advisor?: ICandidateAdvisor;
  status: string;
  rankValue?: number;
  maxRankValue?: number;
}

export class Candidate implements ISignable {
  public id: string;
  public personId: string;
  public opportunityId: string;
  public column?: Column;
  public position: number;
  public created: string | Date;
  public interested?: string | Date;
  public reviewed?: Date;
  public retracted?: Date;
  public ranking?: number;
  public person?: Person;
  public compensation?: Compensation;
  public disqualified?: boolean;
  public applicationStep?: ICandidateApplicationStep;
  public advisor?: ICandidateAdvisor;
  public status: string;
  public rankValue?: number;
  public maxRankValue?: number;

  constructor(data: ICandidate) {
    this.id = data.id;
    this.personId = data.personId;
    this.opportunityId = data.opportunityId;
    this.column = data.column;
    this.position = data.position;
    this.created = data.created;
    this.interested = data.interested;
    this.reviewed = data.reviewed;
    this.retracted = data.retracted;
    this.ranking = data.ranking;
    this.compensation = data.compensation ? new Compensation(data.compensation) : undefined;
    this.disqualified = data.disqualified;
    if (data.applicationStep !== undefined) {
      this.applicationStep = typeof data.applicationStep === "string" ? JSON.parse(data.applicationStep) : data.applicationStep;
    } else {
      this.applicationStep = {} as ICandidateApplicationStep;
    }
    this.advisor = data.advisor ? new CandidateAdvisor(data.advisor) : undefined;
    this.status = data.status;
    this.rankValue = data.rankValue;
    this.maxRankValue = data.maxRankValue;
  }

  public signableId(): string | undefined {
    return this.person && this.person.username;
  }

  public signableType(): SignableType {
    return SignableType.Person;
  }
}
